/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 14th 2022, 7:44:00 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Typography from "@mui/material/Typography";
import { resolveURLName } from "core/routes/utils";
import { DatasetSchema } from "lib/schemas";
import { Image, EmphasisText, OSActionButton, EmptyStateActionWrapper } from "ui-widgets";

interface NoDatasetFieldsCTAProps {
  datasetSchemaId: DatasetSchema["id"];
  datasetSchemaTitle: DatasetSchema["json_schema"]["title"];
  dataBankId: DatasetSchema["data_bank"];
}

export const NoDatasetFieldsCTA = ({ datasetSchemaId, datasetSchemaTitle, dataBankId }: NoDatasetFieldsCTAProps) => {
  const datasetURL = resolveURLName("editDataset", { datasetSchemaId, dataBankId });
  return (
    <EmptyStateActionWrapper
      title={
        <>
          <EmphasisText>{datasetSchemaTitle}</EmphasisText> has no fields
        </>
      }
      description={
        <Typography>
          The dataset named <EmphasisText>{datasetSchemaTitle}</EmphasisText> has no fields. In order for a dataset to
          be referenced, it must have fields. Its easy to add fields to a dataset, just click below to add fields to the
          dataset, <EmphasisText>{datasetSchemaTitle}</EmphasisText>.
        </Typography>
      }
      illustrationGraphic={<Image src="/img/question-mark.png" alt="Onestop Admin" />}
    >
      <OSActionButton variant="contained" size="large" to={datasetURL}>
        Add fields to {datasetSchemaTitle}
      </OSActionButton>
    </EmptyStateActionWrapper>
  );
};
